<div class="about-us-container">
  <div class="about-us-scroll">
    <img class="about-us-top-image" src="assets/setting/banner.png" />
    <div class="about-us-close" (click)="close()">
      <img src="assets/general/down-blue.svg" />
    </div>
    <div class="about-us-title">بنتو</div>
    <div class="about-us-description">
      اپلیکیشن بنتو، با به کارگیری جدیدترین متدهای بروز علم تغذیه، توسط طراحان،
      برنامه‌نویسان و کارشناسان تغذیه، تولید شده است. <br />هدف اصلی ما،
      راهنمایی و همراهی شما در مسیر درست سلامتی است.
    </div>
    <div class="about-us-instagram" (click)="instagram()">
      <img src="assets/setting/instagram.png" />
    </div>
    <div class="about-us-email" (click)="email()">
      <img src="assets/setting/email.png" />
    </div>
    <div class="about-us-call" id="call-button" (click)="call($event)">
      <div class="about-us-call-holder">
        <div class="about-us-call-title-icon">
          <img src="assets/setting/support.png" />
        </div>
        <div class="about-us-call-title">تماس با پشتیبانی</div>
      </div>
    </div>
  </div>
</div>
